<template>
  <path
    d="M23 18.0002V6.00018C23 4.90018 22.1 4.00018 21 4.00018H3C1.9 4.00018 1 4.90018 1 6.00018V18.0002C1 19.1002 1.9 20.0002 3 20.0002H21C22.1 20.0002 23 19.1002 23 18.0002ZM8.9 12.9802L11 15.5102L14.1 11.5202C14.3 11.2602 14.7 11.2602 14.9 11.5302L18.41 16.2102C18.66 16.5402 18.42 17.0102 18.01 17.0102H6.02C5.6 17.0102 5.37 16.5302 5.63 16.2002L8.12 13.0002C8.31 12.7402 8.69 12.7302 8.9 12.9802Z"
  />
</template>
